
























































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator'
import DatePickerComponent from '@/components/DatePickerComponent.vue'
import DateUtils from '@/utils/DateUtils'

@Component({
  components: {
    DatePickerComponent,
  },
})
export default class DepositAmountDialogComponent extends Vue {
  dateUtils = DateUtils.instance

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  /* 請求金額 */
  @Prop({ default: 0 })
  paymenAmount!: number

  /* 分割入金を許可 */
  @Prop({ default: false })
  isPaymentInInstallments!: boolean

  paymentOn = this.dateUtils.getToday()
  amount = 0

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", [Number(this.amount), this.amount == 0 ? null : this.paymentOn])
  }

  @Watch("paymenAmount")
  onChangeDepositAmount() {
    this.amount = this.paymenAmount
  }

}
